import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

const query = gql`
  query {
    allServices(filters: { isV4: true }) {
      edges {
        node {
          dbId
          name
          version
          portfolios
        }
      }
    }
  }
`;

export const useIndicatorServices = () => {
  const { data: rawData, refetch, loading } = useQuery(query, {
    fetchPolicy: 'cache-first',
  });
  const data =
    rawData?.allServices?.edges.length > 0
      ? removeConnectionsMemoized(rawData.allServices)
      : [];
  return { data, refetch, loading };
};
